<!-- Modal
<div class="modal fade" id="exampleModal" #exampleModal tabindex="-1" aria-labelledby="exampleModalLabel" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content " [style]="modalSize">
            <div class="text-end">
                <button type="button" class="btn-close m-2" style="width: 2%; height: 2%;"
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container">
                <div class="modal-body">
                    <div class="row justify-content-center m-3">
                        <h5 class="modal-title text-center" id="exampleModalLabel">Choose Customer Type</h5>
                    </div>
                    <div class="row justify-content-center">
                        <div class="modal-box {{patientBoxStyle}} modal-box-size m-3 text-center p-4"
                        (click)="changeIcons('patientBox')">
                            <img [src]="patientIcon" class="img-size">
                            <p>Patient</p>
                        </div>
                        <div id="caregiver-box" class="modal-box {{caregiverBoxStyle}} modal-box-size m-3 text-center p-4"
                        (click)="changeIcons('caregiverBox')">
                            <img [src]="caregiverIcon" class="img-size">
                            <p>Caregiver</p>
                        </div>
                    </div>
                    <div class="row justify-content-center m-3">
                        <button type="button" class="modal-btn text-white" data-dismiss="modal" aria-label="Close" [style]="continueBtnSize" (click)="onSubmit(exampleModal)">Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<ng-template #modalNotification>
  <div class="modal-header mb--2">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="notificationModal.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row justify-content-center m-3">
      <h1 class="text-center" id="exampleModalLabel">Choose Customer Type</h1>
    </div>
    <div class="row justify-content-center">
      <div
        class="modal-box {{
          patientBoxStyle
        }} modal-box-size m-3 text-center p-4"
        (click)="changeIcons('patientBox')"
      >
        <img [src]="patientIcon" class="img-size" />
        <p>Patient</p>
      </div>
      <div
        id="caregiver-box"
        class="modal-box {{
          caregiverBoxStyle
        }} modal-box-size m-3 text-center p-4"
        (click)="changeIcons('caregiverBox')"
      >
        <img [src]="caregiverIcon" class="img-size" />
        <p>Caregiver</p>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button
      type="button"
      class="modal-btn btn-primary text-white"
      data-dismiss="modal"
      aria-label="Close"
      (click)="onSubmit(exampleModal)"
    >
      Continue
    </button>
  </div>
</ng-template>
